module.exports = {
  production: {
    apiKey: "AIzaSyCVpGyDc1he4Rzvu1xSU9xZEp8wx5tFGiw",
    authDomain: "sourceviewreader.firebaseapp.com",
    databaseURL: "https://sourceviewreader.firebaseio.com",
    projectId: "sourceviewreader",
    storageBucket: "sourceviewreader.appspot.com",
    messagingSenderId: "136711725771",
    appId: "1:136711725771:web:10801ac2469d0d5e",
    measurementId: "G-RW8J1FWXGN",
  },
  staging: {
    apiKey: "AIzaSyAoxDzWrXAD_ODLVXZo3bfw41cN4ZgwEhQ",
    authDomain: "sourceview-reader.firebaseapp.com",
    databaseURL: "https://sourceview-reader.firebaseio.com",
    projectId: "sourceview-reader",
    storageBucket: "sourceview-reader.appspot.com",
    messagingSenderId: "210305534065",
    appId: "1:210305534065:web:5360fd85981d19800b33d0",
  },
}
